import {JsonProperty} from '@hyperloris/tyson';

export class Account {
  @JsonProperty()
  name: string = undefined;

  @JsonProperty()
  type: string = undefined;

  @JsonProperty()
  reference1: string = undefined;

  @JsonProperty()
  reference2: string = undefined;

  @JsonProperty()
  reference3: string = undefined;

}
